'use es6';

export default function isValidURL(string) {
  if (string === undefined) {
    return false;
  }

  const new_pattern = new RegExp('^(https:\\/\\/)(www\\.)?([-a-zA-Z0-9]{1,256}\\.)*hubspot\\.com(\\/[-a-zA-Z\\/0-9@:%_.~#?&=]*)?$');
  return new_pattern.test(string);
}